import { inject, observer } from "mobx-react";
import HeaderComponent from "../../components/shared/HeaderComponent/HeaderComponent";

const Header = inject('loginStore','userStore', 'sharedStore')(observer(HeaderComponent));

export default Header;